import * as React from 'react';
import { CONSTANTS } from '../../assets/UIConstants';
import * as assert from "assert";

interface Props {
    value?: number | string;
    unit?: string;
    valueFontSize?: number;
    marginLeft?: number;
    backgroundColor?: string;
    fontColor?: string;
    decimalPlaces?: number;
}

export class ValueDelta extends React.Component<Props, {}> {

    private style = {
        container: {
            marginLeft: this.props.marginLeft || 20,
            fontSize: this.props.valueFontSize || 22,
            lineHeight: (this.props.valueFontSize || 22) + 'px',
            color: this.props.fontColor || CONSTANTS.COLORS.DELTA_TEXT,
        },
        background: {
            paddingBottom: 2,
            paddingTop: 2,
            paddingLeft: 10,
            paddingRight: 10,
            borderRadius: 15,
            backgroundColor: this.props.backgroundColor || CONSTANTS.COLORS.DELTA_BACKGROUND,
        },
    };

    public static defaultProps: Partial<Props> = {
        value: 0.0,
    };

    private get value(): string {
        assert(undefined != this.props.value, 'CurrentValue#get value - this.props.value was undefined');
        if ('number' === typeof this.props.value) {
            let precision: number = 1;
            if (undefined != this.props.decimalPlaces) {
                precision = this.props.decimalPlaces;
            }
            const prefix = this.props.value! > 0 ? '+' : '';// - sign added automatically
            return prefix + this.props.value!.toFixed(precision);
        }
        return this.props.value || '0';
    }

    public render(): JSX.Element {
        return (
            <div style={this.style.container}>
                <span style={this.style.background}>
                    {this.value}{this.props.unit}
                </span>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/components/ValueDelta.tsx